import React from 'react';
import Radio from '@active/react-ui/Radio';
import Locale from '@active/react-utils/i18n/Locale';
import './CreditCardSwitch.scss';

export const NEW_CREDIT_CARD_OPTION_VALUE = 'showNewCreditCard';

const CreditCardSwitch = () => <Radio
  className="checkout__new-cc__switch-radio"
  name="showNewCreditCard"
  value={NEW_CREDIT_CARD_OPTION_VALUE}
  ariaLabelId="newCardSwitch_label_id">
  <Locale id="checkout.lib.components.creditCard.newCardSwitch.radio.text" />
</Radio>;

export default CreditCardSwitch;
